import { inject, Injectable, Input } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../service/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    private readonly _authService = inject(AuthService);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const result = this._authService.isAuthenticated();

        if (!result) {
            // this._authService.logout('NOT_AUTHENTICATED'); // A kért művelethez először be kell jelentkeznie!
            this._authService.logout('common.error.session.expired.notauthenticated'); // A kért művelethez először be kell jelentkeznie!
        }
        return result;
    }
}
